class FloatingATC {
  constructor() {
    this.element = document.querySelector('[data-floating-atc]');
    if (!this.element) return;

    this.productForm = document.querySelector('.product-form');
    if (!this.productForm) return;

    // Find the main add to cart button
    this.mainAddToCartButton = document.querySelector('.product-form [type="submit"]');
    if (!this.mainAddToCartButton) return;

    // Get settings from data attributes
    this.showImmediately = this.element.dataset.showImmediately === 'true';
    this.scrollPercent = parseFloat(this.element.dataset.scrollPercent) || 50;

    // Initial state
    this.isVisible = false;
    this.scrollRequest = null;

    // Initialize
    this.hide();
    this.checkVisibility(); // Check initial position

    this.setupEventListeners();
    this.setupFormSubmission();
  }

  show() {
    this.element.style.display = 'flex';
    requestAnimationFrame(() => {
      this.element.classList.add('floating-atc--visible');
    });
    this.isVisible = true;
  }

  hide() {
    this.element.classList.remove('floating-atc--visible');
    setTimeout(() => {
      if (!this.isVisible) {
        this.element.style.display = 'none';
      }
    }, 300);
    this.isVisible = false;
  }

  setupEventListeners() {
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    window.addEventListener('resize', () => this.handleScroll(), { passive: true });
    document.addEventListener('variant:changed', (e) => this.handleVariantChange(e));
  }

  handleScroll() {
    if (this.scrollRequest) cancelAnimationFrame(this.scrollRequest);
    this.scrollRequest = requestAnimationFrame(() => {
      this.checkVisibility();
    });
  }

  checkVisibility() {
    // Check if main add to cart button is visible
    const mainButtonRect = this.mainAddToCartButton.getBoundingClientRect();
    const isMainButtonVisible = (
      mainButtonRect.top >= 0 &&
      mainButtonRect.bottom <= window.innerHeight &&
      mainButtonRect.height > 0
    );
    
    // If we're showing immediately when button is not visible
    if (this.showImmediately) {
      if (isMainButtonVisible && this.isVisible) {
        this.hide();
      } else if (!isMainButtonVisible && !this.isVisible) {
        this.show();
      }
      return;
    }
    
    // Otherwise use scroll percentage
    const scrollPosition = window.scrollY;
    const pageHeight = document.body.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / pageHeight) * 100;
    
    const shouldShow = scrollPercentage >= this.scrollPercent && !isMainButtonVisible;
    
    if (shouldShow && !this.isVisible) {
      this.show();
    } else if (!shouldShow && this.isVisible) {
      this.hide();
    }
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;

    // Update price
    const priceElement = this.element.querySelector('.floating-atc__price');
    if (priceElement) {
      priceElement.innerHTML = `
        <span class="price">${Shopify.formatMoney(variant.price, theme.moneyFormat)}</span>
        ${variant.compare_at_price > variant.price ? 
          `<s class="compare-at-price">${Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)}</s>` : ''}
      `;
    }

    // Update mobile price display
    const mobilePriceElement = this.element.querySelector('[data-mobile-price]');
    if (mobilePriceElement) {
      mobilePriceElement.textContent = `- ${Shopify.formatMoney(variant.price, theme.moneyFormat)}`;
    }

    // Update button state
    const button = this.element.querySelector('[data-add-to-cart]');
    const buttonText = this.element.querySelector('[data-add-to-cart-text]');
    
    if (button && buttonText) {
      button.disabled = !variant.available;
      buttonText.textContent = variant.available ? 
        this.element.dataset.addToCartText : 
        this.element.dataset.soldOutText;
    }
  }

  setupFormSubmission() {
    const floatingButton = this.element.querySelector('[data-add-to-cart]');
    if (floatingButton && this.productForm) {
      floatingButton.addEventListener('click', (e) => {
        e.preventDefault();
        const submitButton = this.productForm.querySelector('[type="submit"]');
        if (submitButton) submitButton.click();
      });
    }
  }
}

// Initialize only on product pages
if (window.location.pathname.includes('/products/')) {
  document.addEventListener('DOMContentLoaded', () => new FloatingATC());
}